// libs
import { useEffect, useState } from "react";
import { Search } from "lucide-react";

// custom hooks
import useProducts from "../../hooks/useProducts";
import useToken from "../../hooks/useToken";

// components
import Product from "../Product";

// styles
import classes from "./styles.module.css";
import CustomInput from "../CustomInput";

export default function ProductsList() {
  const { products, fetchProducts } = useProducts();
  const [search, setSearch] = useState("");
  const [token] = useToken();

  useEffect(() => {
    fetchProducts(token);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.searchContainer}>
        <Search size={14} />
        <CustomInput
          className={classes.search}
          value={search}
          setValue={setSearch}
          defaultPlaceholder="Поиск по названию.."
        />
      </div>

      <div className={classes.products}>
        {(search !== ""
          ? products.filter((p) =>
              p.title.toLowerCase().includes(search.toLowerCase()),
            )
          : products
        ).map((product) => (
          <Product key={product.id} data={product} />
        ))}
      </div>
    </div>
  );
}
